import { Injectable } from "@angular/core";
import { AppConfigService } from "./app-config.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

interface GuidResponse {
  guid: string;
}

interface ManyGuidsResponse {
  guids: string[];
}

@Injectable({
  providedIn: "root"
})
export class GuidService {
  constructor(private appConfigService: AppConfigService, private http: HttpClient) {}

  getManyGuids$(): Observable<string[]> {
    return this.http
      .get<ManyGuidsResponse>(this.appConfigService.getManyGuidsUrl(1000))
      .pipe(map(response => response.guids));
  }

  getGuid$(): Observable<string> {
    return this.http
      .get<GuidResponse>(this.appConfigService.getConfig().getGuidApiUrl)
      .pipe(map(response => response.guid));
  }
}
